// frontend/src/utils/policy/localRuntimePolicyProvider.js
//
// Current hardcoded provider. It adapts the already-resolved runtime shaping
// policy into the typed response-policy contract.
//
// FUTURE API NOTE:
// Do not replace this provider with a raw HTTP prompt response. Add additional
// providers (tenant/domain/remote API), validate each returned policy object,
// then resolve authority and precedence in resolveEffectiveResponsePolicy.js.

import {
  createResponsePolicy,
  RESPONSE_POLICY_SOURCES,
} from './responsePolicyContract';

function getFallbackResponse(mode = '') {
  if (mode === 'analytical_continuation') {
    return 'I’ll continue from the evidence already established in the conversation.';
  }

  if (mode === 'pending_answer') {
    return 'I’ll use that answer and continue from the established context.';
  }

  return '';
}

export function getLocalRuntimeResponsePolicy(context = {}) {
  const shapingPolicy = context.shapingPolicy || {};
  const mode = shapingPolicy.mode || 'normal';

  return createResponsePolicy({
    policyId: 'daisy.response.runtime',
    version: '1.0.0',
    source: RESPONSE_POLICY_SOURCES.RUNTIME,
    authority: 'runtime_state',
    scope: 'response_output',
    priority: 100,
    provenance: {
      responseIntent: shapingPolicy.responseIntent || context.responseIntent || null,
      turnId: context.turnId || null,
    },
    mode,
    responseIntent: shapingPolicy.responseIntent || context.responseIntent || 'ANSWER_NORMALLY',
    rules: {
      allowOptionalQuestion: shapingPolicy.allowOptionalQuestion,
      questionAuthority: shapingPolicy.questionAuthority,
      requireReasoningAdvance: shapingPolicy.requireReasoningAdvance,
      relationshipCentered: shapingPolicy.relationshipCentered,
      avoidAmplification: shapingPolicy.avoidAmplification,
    },
    fallbackResponse: getFallbackResponse(mode),
  });
}

export default getLocalRuntimeResponsePolicy;
